import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import assign from '../../_helpers/assign.js';
// creates sorting method and returns it (sort, reverse, sort_, reverse_)
export default function createSortingMethod(name, hasOptions) {
  return function pseudoNativeMethod(sortCallback) {
    syncFields(this);
    // as the native sort; sort_ may take its options object in that place
    if (name === 'sort' && !hasOptions && sortCallback !== undefined && typeof sortCallback !== 'function') {
      throw new TypeError('The comparison function must be either a function or undefined');
    }
    if (this.length < 2) return this;
    var givenEventOptions = hasOptions ? arguments[arguments.length - 1] : null;
    var method = Array.prototype[name];
    var eventOptions = {
      method: name,
      self: this,
      added: [],
      removed: []
    };
    // call original method
    if (name === 'sort' && typeof sortCallback === 'function') {
      method.call(this, sortCallback);
    } else {
      method.call(this);
    }
    // extend event options by custom event options if they are given
    if (hasOptions) {
      if (givenEventOptions && typeof givenEventOptions === 'object') {
        assign(eventOptions, givenEventOptions);
      }
    }
    reportModified(this, eventOptions);
    return this;
  };
}